// src/components/Employees.js

import React, { useEffect, useState } from 'react'

import Input from 'components/Input'
import ButtonPrimary from 'components/ButtonPrimary'
import Toggle from 'components/Toggle'

import { faAngleDoubleLeft, faBan, faCheckCircle, faRefresh } from '@fortawesome/free-solid-svg-icons'

import { PERMISSIONS, USER_TYPES, hasFeature } from "lib/user-utils"

import styles from './styles.module.scss'

const EditEmployee = ({ bondsman, user: employee, onClose, onDeleteUser, onResetUser, onUpdateUser }) => {
  const [info, setInfo] = useState(null)
  const [permissions, setPermissions] = useState(null)

  useEffect(() => {
    if (!info) {
      const params = {
        type: employee.type,
        nameFirst: employee.nameFirst,
        nameLast: employee.nameLast,
        phone: employee.phone,
        email: employee.email,
        slug: employee.slug,
        permissions: employee.permissions || [],
        textNotification: employee?.notifications?.types?.text || false,
        emailNotification: employee?.notifications?.types?.email || false,
        isTrainingMode: employee?.isTrainingMode || false
      }
      setInfo(params)
    }
  }, [info, employee])

  const { restrictedPermissions } = bondsman

  useEffect(() => {
    if (!permissions) setPermissions(() => restrictedPermissions || [])
  }, [permissions, restrictedPermissions])

  const _getAllPermissions = () => {
    let allPermissions = []
    PERMISSIONS.forEach(group => allPermissions = allPermissions.concat(group.options))
    return allPermissions
  }

  const _onChangeEmployeePermission = (id, isOn) => {
    if (isOn) {
      info.permissions.push(id)
    } else {
      info.permissions = info.permissions.filter(itm => itm !== id)
    }
    setInfo(() => info)
  }

  const _onTextChange = (id, val) => setInfo(i => { return { ...i, [id]: val } })

  if (info) {
    let allowedPermissions = [...employee.permissions]
    // if (employeePermissionChanges[employee.id]) {
    //   allowedPermissions = [...allowedPermissions, ...employeePermissionChanges[employee.id]]
    // }
    const allPermissions = _getAllPermissions()
    return (
      <>
        <section className={styles.formSection}>
          <header>
            <ButtonPrimary small color="orange" icon={faRefresh} onClick={onResetUser}>Reset</ButtonPrimary>
            <ButtonPrimary small color="red" icon={faBan} onClick={onDeleteUser}>Disable</ButtonPrimary>
          </header>
          <div className={styles.formSection__area}>
            <div className={styles.splitRow}>
              <Input type="text" id="nameFirst" label="First Name" value={info?.nameFirst || ''} onChange={_onTextChange} isRequired />
              <Input type="text" id="nameLast" label="Last Name" value={info?.nameLast || ''} onChange={_onTextChange} isRequired />
            </div>
            <div className={styles.splitRow}>
              <Input type="text" id="email" label="Email Address" value={info?.email || ''} onChange={_onTextChange} isRequired />
              <Input type="text" id="phone" label="Phone Number" value={info?.phone || ''} onChange={_onTextChange} isRequired />
            </div>
            <div className={styles.splitRow}>
              <Input type="select" id="type" label="User Type" defaultValue={info?.type || null} dropdownOptions={USER_TYPES} onChange={_onTextChange} isRequired />
            </div>
          </div>
        </section>
        <section className={styles.formSection__area}>
          <h5 className="rad">Notifications</h5>
          <Toggle id="textNotification" name="textNotification" checked={info?.textNotification || false} text="Do you want to receive Text Notifications?" isYesNo onChange={_onTextChange} />
          <Toggle id="emailNotification" name="emailNotification" checked={info?.emailNotification || false} text="Do you want to receive Email Notifications?" isYesNo onChange={_onTextChange} />
        </section>
        {restrictedPermissions?.length > 0 && (
          <section className={styles.formSection__area}>
            <h5 className="rad">Permissions</h5>
            {permissions?.length > 0 && permissions.map((p, pKey) => {
              const perm = allPermissions.find(itm => itm.type === p)
              if (perm && hasFeature(bondsman, perm.features)) {
                return (
                  <div key={pKey} className={styles.permission}>
                    <div className={styles.permission__left}>
                      <h4>{perm.title}</h4>
                      <p>{perm.description}</p>
                    </div>
                    <div className={styles.permission__right}>
                      <Toggle 
                        isYesNo
                        id={perm.type}
                        name={perm.type}
                        checked={(allowedPermissions.indexOf(perm.type) >= 0)}
                        onChange={(id, isOn) => _onChangeEmployeePermission(id, isOn)}
                      />
                    </div>
                  </div>
                )
              }
              console.error('Not Found: ', p)
              return null
            }).filter(itm => !!itm)}
          </section>
        )}
        <div className={styles.formSection__actions}>
          <ButtonPrimary fullWidth color="grey" icon={faAngleDoubleLeft} onClick={onClose}>Cancel</ButtonPrimary>
          <ButtonPrimary fullWidth color="navy" icon={faCheckCircle} onClick={() => onUpdateUser(info)}>Save</ButtonPrimary>
        </div>
      </>
    )
  }
  return null
}

export default EditEmployee